export type OfferingStatus = 'Live' | 'Private Preview' | 'Coming Soon'

export type OfferingIconKey =
  | 'lc'
  | 'sanctions'
  | 'cbam'
  | 'eudr'
  | 'decision'
  | 'duty'
  | 'audit'

export interface PublicOffering {
  name: string
  brand?: string
  tagline: string
  description: string
  href: string
  cta: string
  price: string
  status: OfferingStatus
  iconKey: OfferingIconKey
}

export const selfServeOfferings: PublicOffering[] = [
  {
    name: 'LC Pack Review',
    brand: 'LCopilot',
    tagline: 'Documentary examination before presentation',
    description:
      'Upload an LC and its supporting documents. Check required documents, LC terms, and cross-document consistency, then download a cited examination report.',
    href: '/lcopilot',
    cta: 'Check an LC pack',
    price: 'Pay per review',
    status: 'Live',
    iconKey: 'lc',
  },
  {
    name: 'Sanctions Screening',
    tagline: 'Defined checks against supported lists',
    description:
      'Screen parties, vessels, goods, or batch files against supported OFAC, UN, and UK lists. Unscreened records are never presented as clear.',
    href: '/sanctions',
    cta: 'Run a screening',
    price: 'Self-serve',
    status: 'Live',
    iconKey: 'sanctions',
  },
  {
    name: 'CBAM Readiness',
    tagline: 'Supplier evidence for EU carbon reporting',
    description:
      'Check whether goods are in scope and identify the emissions, installation, and supplier evidence an EU customer will need.',
    href: '/tools/cbam-readiness-check',
    cta: 'Check CBAM readiness',
    price: 'Free scope check',
    status: 'Live',
    iconKey: 'cbam',
  },
  {
    name: 'EUDR Readiness',
    tagline: 'Supplier evidence for deforestation due diligence',
    description:
      'Check whether goods are in scope and identify gaps in geolocation, legality, traceability, and cutoff-date evidence.',
    href: '/tools/eudr-readiness-check',
    cta: 'Check EUDR readiness',
    price: 'Free scope check',
    status: 'Live',
    iconKey: 'eudr',
  },
]

export const managedOfferings: PublicOffering[] = [
  {
    name: 'Verified Trade Decision Pack',
    brand: 'Proofline',
    tagline: 'One shipment, reconstructed and reviewed',
    description:
      'Bring the parties, order, shipment, documents, credentials, and payment evidence into one case. Enso investigates gaps and delivers a decision pack for your team.',
    href: '/proofline',
    cta: 'Start a trade case',
    price: 'From $3,000/month',
    status: 'Live',
    iconKey: 'decision',
  },
  {
    name: 'Duty Audit',
    tagline: 'Customs entry analysis and recovery support',
    description:
      'Normalize import records, test classification, value, origin, and duty treatment, then quantify supported recovery opportunities and exposure.',
    href: '/duty-audit',
    cta: 'Request private preview',
    price: 'From $5,000 + recovery fee',
    status: 'Private Preview',
    iconKey: 'duty',
  },
  {
    name: 'Trade Audit',
    tagline: 'Transaction and control review',
    description:
      'Examine transaction data and company controls, identify recurring compliance failures, and receive a prioritized remediation plan.',
    href: '/trade-audit',
    cta: 'Join early access',
    price: 'Trade Risk Scan from $10,000',
    status: 'Coming Soon',
    iconKey: 'audit',
  },
]
